module.exports = __webpack_public_path__ + "img/15手机.622d8a3e.png";